<template>
    <div v-if="loading_cert === true">
      <loading />
    </div>
    <div v-else>
      <div class="col s12 m12 no-padding doc-type-section">
        <div class="input-field col s12 m6">
          <select v-model="certidao.pf_cert_tipo" id="dep_cert_nasc_num" type="text" class="validate">
            <option value="" selected>Selecione</option>
            <option value="N">Nascimento</option>
            <option value="C">Casamento</option>
          </select>
          <label for="dep_cert_nasc_num">Tipo de Certidão</label>
        </div>
        <div class="input-field col s12 m6">
          <input v-model="certidao.pf_cert" id="dep_cert_nasc_num" type="text" class="validate">
          <label for="dep_cert_nasc_num">Número</label>
        </div>
        <div class="input-field col s12 m6">
          <input v-model="certidao.pf_cert_livro" id="dep_cert_nasc_livro" type="text" class="validate">
          <label for="dep_cert_nasc_livro">Livro</label>
        </div>
        <div class="input-field col s12 m6">
          <input v-model="certidao.pf_cert_pagina" id="dep_cert_nasc_pagina" type="text" class="validate">
          <label for="dep_cert_nasc_pagina">Página</label>
        </div>
      </div>
      <div class="input-field col s12 m12">
        <button @click="prepareSubmitCertNascCas" v-bind:disabled="verificaForm === false" class="btn right" type="button">SALVAR</button>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import {converteData, formataData} from '@/assets/js/form-utils.js'
import {CONFIG} from '@/config/config.js'
import SocialService from '@/services/social-service.js'
import { verificaData } from '@/assets/js/form-utils'
import sha1 from 'js-sha1'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'CertNascCas',
  components: {
    'loading': Loading,
  },
  props: {
      doc: Object,
      pf_id: String
  },
  data (){
    return {
      loading_cert: false,
      meta: this.$store.state.meta.data,
      certidao: {
        pf_cert: this.doc.cert,
        pf_cert_livro: this.doc.cert_livro,
        pf_cert_pagina: this.doc.cert_pagina,
        pf_cert_tipo: this.doc.cert_tipo,
      },
      error_fields: {},
      loaded: null,      
    }
  },
  computed: {
    verificaForm: function() {
        let status = Object.keys(this.certidao).filter((k) => this.certidao[k] && this.certidao[k] != '').length === 4
        this.$emit('statusChange', {
          doc: 5,
          status: status
        })
        return status
    }
  },
  methods: {
    async submitInsertCertNascCas(cert){
      axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/cert/`, {
        ...cert,
        ...{
          'pf_id': this.pf_id,
          'device': await socialService.getDeviceInfo()
        }
      })
      .then((response) => {
        this.loading_cert = false
        setTimeout(() => {
          this.initFields()
          this.$emit('docSaved', 4)
        }, 100)
      })
      .catch((error) => {
        M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        this.loading_cert = false
        setTimeout(() => {
          this.initFields()
        }, 100)
      })
    },
    prepareSubmitCertNascCas(){
      this.loading_cert = true
      let a = this.certidao //Atual

      let certidao = {
        pf_id: this.pf_id,
        pf_cert: this.certidao.pf_cert,
        pf_cert_livro: this.certidao.pf_cert_livro,
        pf_cert_pagina: this.certidao.pf_cert_pagina,
        pf_cert_tipo: this.certidao.pf_cert_tipo
      }

      if(this.loaded !== sha1(JSON.stringify(certidao))){
        return this.submitInsertCertNascCas(certidao)
      } else {
        this.loading_cert = false
        this.$emit('docSaved', 4)
      }
    },
    initFields () {
      M.updateTextFields()
      M.FormSelect.init(document.querySelectorAll('select'))
    },
    verificaStatusDocumento(){
      return true //Não obrigatório
    }
  },
  mounted(){
    this.loaded = sha1(JSON.stringify({
      pf_id: this.pf_id,
      pf_cert: this.certidao.pf_cert,
      pf_cert_livro: this.certidao.pf_cert_livro,
      pf_cert_pagina: this.certidao.pf_cert_pagina,
      pf_cert_tipo: this.certidao.pf_cert_tipo
    }))

    this.initFields()
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/steps/documentos/CertNascCas.vue